import { ISupportTopic } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

export const initialTopics = [
  'Current News',
  'Opening Comments',
  'Macroeconomics',
  'Hybrid Work',
  'SupplyChain Assurance',
  'Innovation',
  'Sustainability',
  'Security',
  'Services',
]

export const initialSupportData: ISupportTopic[] = initialTopics.map((topic) => ({
  TopicArea: topic,
  TalkingPoints: '',
}))
